import { Button } from "antd";
import { useViewerStore } from "../../../../../store/store";
import { EnggSectionType } from "../../../../../@types/enums";

const EngineeringConfirm = ({ type }: { type: EnggSectionType; }) => {

    const { sceneViewer, isRoofChange, isEngineeringFieldsChange, isRefreshDone } = useViewerStore.getState();
    const cancel = () => sceneViewer.viewerAlert({ show: false });

    let confirmMessage = "";
    if (isRoofChange && !isRefreshDone) {
        confirmMessage = `Please save the roof details and update the ${type} before downloading.`;
    } else if (!isRoofChange && isEngineeringFieldsChange && !isRefreshDone) {
        confirmMessage = `Please update the ${type} before downloading.`;
    } else if (isRoofChange === true) {
        confirmMessage = "Please save the roof details before downloading.";
    }

    return (
        <>
            <p className="report-text">{confirmMessage}</p>
            <br />

            <div className={"modal-bottom-action-button-container"}>
                <Button
                    type="primary"
                    size="large"
                    danger
                    className="editor__control--finalize modal-cancel-button"
                    onClick={cancel}
                >
                    OK
                </Button>
            </div>
        </>
    );
};

export default EngineeringConfirm;
